import { render } from "./LogoWrapper.vue?vue&type=template&id=55c8064b&scoped=true"
import script from "./LogoWrapper.vue?vue&type=script&lang=js"
export * from "./LogoWrapper.vue?vue&type=script&lang=js"

import "./LogoWrapper.vue?vue&type=style&index=0&id=55c8064b&scoped=true&lang=css"

import exportComponent from "/www/wwwroot/plus.centrodeglaucoma.com/darmin-plus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55c8064b"]])

export default __exports__